<div class="container p-4 border rounded shadow-sm bg-light">
  <!-- Header -->
  <div *ngIf="title" class="text-center mb-4">
    <h1 class="fw-bold">{{ title }}</h1>
  </div>
  <div *ngIf="subtitle" class="text-center mb-4">
    <h3 class="fw-bold">{{ subtitle }}</h3>
  </div>

  <!-- Table -->
  <div class="table-responsive">
    <table class="table table-borderless detail-table">
      <tbody>
        <ng-container *ngFor="let item of visibleItems; let i = index">
          <!-- column pairs -->
          <tr *ngIf="!item.colspan && i % 2 === 0">
            <!-- current item -->

            <td class="fw-bold">
              <div class="d-flex align-items-center">
                <mat-icon *ngIf="item.icon" class="me-2">{{
                  item.icon
                }}</mat-icon>
                {{ item.label }}
              </div>
            </td>

            <td>
              {{ item.value ?? "Dato faltante" }}
            </td>

            <!-- next item -->
            <ng-container
              *ngIf="visibleItems[i + 1] && !visibleItems[i + 1].colspan">
              <td class="fw-bold">
                <div class="d-flex align-items-center">
                  <mat-icon *ngIf="visibleItems[i + 1].icon" class="me-2">{{
                    visibleItems[i + 1].icon
                  }}</mat-icon>
                  {{ visibleItems[i + 1].label }}
                </div>
              </td>

              <td>
                {{ visibleItems[i + 1].value ?? "Dato faltante" }}
              </td>
            </ng-container>
          </tr>

          <!-- full column -->
          <tr *ngIf="item.colspan === 4">
            <td class="fw-bold">
              <div class="d-flex align-items-center">
                <mat-icon *ngIf="item.icon" class="me-2">{{
                  item.icon
                }}</mat-icon>
                {{ item.label }}
              </div>
            </td>

            <td colspan="3">
              {{ item.value ?? "Dato faltante" }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
